import * as styles from './styles.css';
import * as React from 'react';
import { PROMO_ICON } from '../constants/icons';

export function DiscountIcon() {
  return (
    <div className={styles['container']}>
      <img src={PROMO_ICON.get('discount')} className={styles['icon-img']} />
    </div>
  );
}
